import styled from 'styled-components';

export const Container = styled.div`
  width: 88%;
  height: 145px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  gap: 0.5rem;
  border-radius: 1.5rem;
  background: ${({ theme }) => theme.colors.background_white};
  box-shadow: 0px 1px 9px #00000029;
  position: relative;

  .containerProfilePicture {
    display: flex;
    width: 100%;
    justify-content: center;

    .contentProfilePicture {
      border-radius: 100%;
      width: 10rem;
      height: 10rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: transparent;
      overflow: hidden;
      position: absolute;
      top: -4.5rem;
      box-shadow: 0px 1px 9px #00000029;

      .empty {
        background-color: ${({ theme }) => theme.colors.background_white};

        svg {
          margin-left: -16%;
          margin-bottom: -16%;
          width: 132%;
          height: 132%;
        }
      }

      img {
        width: 10rem;
        height: 10rem;
      }
    }
  }

  .containerChangePicture {
    max-width: 12rem;
    min-width: 12rem;
    display: flex;
    justify-content: flex-end;
    margin-top: 3rem;

    .changePicture {
      color: ${({ theme }) => theme.colors.tertiary_500};
      font-size: 1.4rem;
      cursor: pointer;
      overflow: visible;
      min-width: 2rem;
      padding: 0;
    }
  }

  .contentDataUser {
    display: flex;
    flex-direction: column;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    .nameUser {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      width: 100%;
      h1 {
        max-width: 8rem;
        font-size: 1.8rem;
        display: block;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.secondary};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    h1 {
      display: flex;
      align-items: center;

      font-size: 1.5rem;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.secondary};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    a {
      font-size: 1rem;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.primary};
    }

    .content {
      display: inline-grid;
      align-items: center;
    }
  }

  @media (max-width: 767px) {
    width: -webkit-fill-available;
    min-height: 203px;
    height: 203px;
    margin: 0 5px 0 5px;
    gap: 1.5rem;

    .contentDataUser {
      gap: 1rem;

      a {
        font-size: 1.5rem;
      }
    }
  }

  @media (max-width: 500px) {
    height: auto;
    min-height: auto;
    flex-direction: row;
    gap: 0;

    .containerProfilePicture {
      align-self: flex-start;
      width: auto;

      .contentProfilePicture {
        width: 5rem;
        height: 5rem;
        position: initial;
      }
    }

    .containerChangePicture {
      justify-content: flex-start;
      max-width: initial;
      min-width: auto;
    }

    .contentDataUser {
      align-items: flex-start;
      gap: 0.5rem;
    }
  }

  @media (max-width: 350px) {
    .containerProfilePicture {
      display: none;
    }

    .contentDataUser {
      a {
        align-self: center;
      }

      .content h1 {
        font-size: 1rem;
      }
    }
  }
`;
